export default function AboutMe() {
  return (
    <section id="AboutMe" className="about--section">
      <div className="hero--section--content--box about--section--box">
        <div className="hero--section--content">
          <p className="section--title">Who Is This?</p>
          {/* <h1 className="skills-section--heading">About Me</h1> */}
          <p className="hero--section-description">
            Student from Faculty of Information Technology University of
            Moratuwa.
          </p>
          <p className="hero--section-description">
            Associate Software Engineer, Freelancer <br></br>
          </p>
        </div>
      </div>
      <div
        className="about--section--img22"
        style={{
          width: "80%", // Adjust width to make it smaller
          maxWidth: "300px", // Limit the maximum width
          height: "auto", // Maintain aspect ratio
        }}
      >
        <img
          src="./img/userimg.png"
          alt="About Me"
          style={{
            width: "100%", // Make the image responsive within the div
            height: "auto", // Maintain aspect ratio
          }}
        />
      </div>
    </section>
  );
}
